/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Categoryid2Inputs */

const en__field_categoryid2 = /** @type {(inputs: _Field_Categoryid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

const de__field_categoryid2 = /** @type {(inputs: _Field_Categoryid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie`)
};

/**
* | output |
* | --- |
* | "Category" |
*
* @param {_Field_Categoryid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_categoryid2 = /** @type {((inputs?: _Field_Categoryid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Categoryid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_categoryid2(inputs)
	return de__field_categoryid2(inputs)
});
export { _field_categoryid2 as "_field_categoryID" }